import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

// docs/17-environment-and-config.md — the only place that reads process.env.
export const env = createEnv({
  server: {
    API_URL: z.url(),
    SESSION_SECRET: z.string().min(32),
    NODE_ENV: z.enum(["development", "test", "production"]).default("development"),
    // Sentry source map upload at build time (docs/13-error-handling.md#error-tracking). All optional.
    SENTRY_AUTH_TOKEN: z.string().min(1).optional(),
    SENTRY_ORG: z.string().min(1).optional(),
    SENTRY_PROJECT: z.string().min(1).optional(),
    // The shared UI kit demo at /__kit (FND-16, U5): development and test builds only
    KIT_ENABLED: z
      .enum(["true", "false"])
      .default("false")
      .transform((value) => value === "true"),
    // `next dev` behind a domain (shared dev server): comma-separated hostnames it may serve
    DEV_ORIGINS: z
      .string()
      .optional()
      .transform((value) => value?.split(",").map((host) => host.trim()) ?? []),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.url(),
    // Error tracking is off unless this is set
    NEXT_PUBLIC_SENTRY_DSN: z.url().optional(),
  },
  runtimeEnv: {
    API_URL: process.env.API_URL,
    SESSION_SECRET: process.env.SESSION_SECRET,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    SENTRY_AUTH_TOKEN: process.env.SENTRY_AUTH_TOKEN,
    SENTRY_ORG: process.env.SENTRY_ORG,
    SENTRY_PROJECT: process.env.SENTRY_PROJECT,
    KIT_ENABLED: process.env.KIT_ENABLED,
    DEV_ORIGINS: process.env.DEV_ORIGINS,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  },
  // Lets Docker builds and lint-only CI jobs run without real values.
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
});
